var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['svgIcon',_vm.size],attrs:{"title":_vm.title},domProps:{"innerHTML":_vm._s(_vm.html)}})}
var staticRenderFns = []

export { render, staticRenderFns }